module.exports = __webpack_public_path__ + "static/media/Picp2.17aaae3e.png";